import CuentaContableService from "@/services/conta/CuentaContableService";
import ConTipoPoliza from "@/services/conta/ConTipoPoliza";
import EjercicioService from "@/services/conta/EjercicioService";

const tipos_polizas = (context, params) => {
  return ConTipoPoliza.fetch(params)
    .then(res => {
      context.commit('TIPO_POLIZA', res.data);
    });
};

const tipo_cuenta_contable = (context, params) => {
  return ConTipoPoliza.fetch(params)
    .then(res => {
      context.commit('TIPO_CUENTA_CONTABLE', res.data);
    });
};

const cuenta_contable = (context, params) => {
  return CuentaContableService.fetch(params)
    .then(res => {
      context.commit('CUENTA_CONTABLE', res.data);
    });
};

const cuentas_contables = (context, params) => {
  return CuentaContableService.fetch(params)
    .then(res => {
      context.commit('CUENTAS_CONTABLES', res.data);
    });
};


const ejercicios = (context, params) => {
  return EjercicioService.fetch(params)
    .then(res => {
      context.commit('EJERCICIOS', res.data);
    });
};


export default {
  tipos_polizas,
  tipo_cuenta_contable,
  cuenta_contable,
  cuentas_contables,
  ejercicios,
};